import { useCallback, useMemo } from "react";

function safeParse(value) {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

export default function useLabCheckoutSession(slug, clientId) {
  const storageKey = useMemo(() => {
    const safeSlug = String(slug || "").trim() || "unknown";
    const safeClient = String(clientId || "default").trim() || "default";
    return `lab_checkout_session:${safeClient}:${safeSlug}`;
  }, [clientId, slug]);

  const restore = useCallback(() => {
    if (!slug) return null;
    const parsed = safeParse(sessionStorage.getItem(storageKey));
    if (!parsed || parsed.slug !== slug) return null;
    return parsed;
  }, [slug, storageKey]);

  const save = useCallback((state) => {
    if (!slug || !state || typeof state !== "object") return;
    sessionStorage.setItem(
      storageKey,
      JSON.stringify({
        ...state,
        slug,
        clientId: clientId || "default",
        savedAt: new Date().toISOString(),
      })
    );
  }, [clientId, slug, storageKey]);

  const clear = useCallback(() => {
    sessionStorage.removeItem(storageKey);
  }, [storageKey]);

  return { restore, save, clear, storageKey };
}
